"use client";

import * as React from "react";
import Link from "next/link";
import { Icons } from "@/components/icons";
import { siteConfig } from "@/lib/site";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";

export function SiteMainNav() {
  const t = useTranslations("General");

  const { locale } = useRouter();
  return (
    <div className="flex">
      <Link href="/" className="flex items-center mr-4 space-x-2">
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <Icons.logo className="w-5 h-5 mr-2" />
          <span className="hidden font-semibold text-md md:block">
            {siteConfig.name}
          </span>
        </div>
      </Link>

      <Link
        href={
          "https://tunis.events/" + (locale == "fr" ? locale : "") + "/cinema"
        }
        className="flex items-center mr-4 space-x-2"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">
            /cinema
          </span>
        </div>
      </Link>

      <Link
        href={
          "https://tunis.events/" + (locale == "fr" ? locale : "") + "/artists"
        }
        className="flex items-center mr-4 space-x-2"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">
            /artistes
          </span>
        </div>
      </Link>

      <Link
        href={
          "https://tunis.events/" + (locale == "fr" ? locale : "") + "/brands"
        }
        className="flex items-center mr-4 space-x-2"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">
            /collectifs
          </span>
        </div>
      </Link>
      <Link
        href={
          "https://tunis.events/" + (locale == "fr" ? locale : "") + "/labels"
        }
        className="flex items-center mr-4 space-x-2"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">
            /labels
          </span>
        </div>
      </Link>
      <Link
        href={
          "https://tunis.events/" + (locale == "fr" ? locale : "") + "/places"
        }
        className="flex items-center mr-4 space-x-2"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">
            /lieux
          </span>
        </div>
      </Link>
      <Link
        href="https://codebar.tunis.events/"
        className="flex items-center mr-4 space-x-2"
        target="_blank"
      >
        <div className="flex items-center transition-opacity duration-200 opacity-60 hover:opacity-100">
          <span className="hidden font-medium text-[15px] md:block">/play</span>
        </div>
      </Link>
    </div>
  );
}
